import { ColorRGBA64, rgbToRelativeLuminance } from "@microsoft/fast-colors";
import { contrast } from "./utilities/relative-luminance.js";
/**
 * Represents a color in a {@link Palette} using RGB.
 *
 * @public
 */
export class SwatchRGB {
    /**
     * Creates a new SwatchRGB.
     *
     * @param red - Red channel expressed as a number between 0 and 1
     * @param green - Green channel expressed as a number between 0 and 1
     * @param blue - Blue channel expressed as a number between 0 and 1
     */
    constructor(red, green, blue) {
        /**
         * Gets the contrast between this Swatch and another.
         *
         * @returns The contrast between the two luminance values, for example, 4.54
         */
        this.contrast = contrast.bind(null, this);
        /**
         * Gets this color value as a string for use in css.
         *
         * @returns The color value in a valid css string format
         */
        this.createCSS = this.toColorString;
        this.r = red;
        this.g = green;
        this.b = blue;
        this.color = new ColorRGBA64(red, green, blue);
        this.relativeLuminance = rgbToRelativeLuminance(this.color);
    }
    /**
     * Gets this color value as a string.
     *
     * @returns The color value in string format
     */
    toColorString() {
        return this.color.toStringHexRGB();
    }
    /**
     * Creates a new SwatchRGB from and object with R, G, and B values expressed as a number between 0 to 1.
     *
     * @param obj - An object with `r`, `g`, and `b` values expressed as a number between 0 and 1
     * @returns A new SwatchRGB
     */
    static from(obj) {
        return new SwatchRGB(obj.r, obj.g, obj.b);
    }
}
